import React from 'react';
import { Card, Accordion } from 'react-bootstrap';
import BondRepaymentMonthly from './BondRepaymentMonthly';
import BondRepaymentLumpSum from './BondRepaymentLumpSum';

const BondRepayment: React.FC = () => {
  return (
    <Card.Body className="p-2">
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Card className="mb-1">
            <Card.Header className="p-0">
              <Accordion.Button className="text-start w-100 btn btn-secondary py-2" style={{ letterSpacing: '0.5px', fontSize: '13px' }}>
                Monthly Installments
              </Accordion.Button>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <div>
                <BondRepaymentMonthly />
              </div>
            </Accordion.Collapse>
          </Card>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Card className="mb-1">
            <Card.Header className="p-0">
              <Accordion.Button className="text-start w-100 btn btn-secondary py-2" style={{ letterSpacing: '0.5px', fontSize: '13px' }}>
                Lump Sum Payment
              </Accordion.Button>
            </Card.Header>
            <Accordion.Collapse eventKey="1">
              <div>
                <BondRepaymentLumpSum />
              </div>
            </Accordion.Collapse>
          </Card>
        </Accordion.Item>
      </Accordion>
    </Card.Body>
  );
};

export default BondRepayment;
